export const UseGetAllMealAds = async () => {
	try {
		console.log("process.env.REACT_APP_API_URL: ", process.env.REACT_APP_API_URL);
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/meal/get_all_ads`, {
			method: 'GET',
			headers: {'Content-Type': 'application/json'},
			// credentials: 'include',
			// mode: 'cors'
		});
		let result = null;
		const status = response.status;
		if (status === 200) {
			result = await response.json();
		}
		return { result, status };
	} catch (e) {
		console.log(e);
	}
}

export const UseGetAllActiveMealAds = async (userId?: any) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/meal/get_all_active_ads/${userId || ''}`, {
			method: 'GET',
			headers: {'Content-Type': 'application/json'},
		});
		let result = null;
		const status = response.status;
		if (status === 200) {
			result = await response.json();
		}
		return { result, status };
	} catch (e) {
		console.log(e);
	}
}

export const UseGetMealAdById = async (mealId: string) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/meal/get_meal_by_id/${mealId}`, {
			method: 'GET',
			headers: {'Content-Type': 'application/json'},
			// credentials: 'include',
			// mode: 'no-cors'
		});
		let result = null;
		const status = response.status;
		if (status === 200) {
			result = await response.json();
		}
		return { result, status };
	} catch (e) {
		console.log(e);
	}
}

export const AddMealToCart = async (userId: string, meal: any) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/cart/add-meal`, {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			credentials: 'include',
			body: JSON.stringify({
				userId,
				meal
			}),
		});
		
		const data = await response.json();
		if (response && response.status === 201 && data) {
			console.log("AddMealToCart data: ", data);
			return data;
		} else {
			//data && data.message && toast.error(data.message);
			return null;
		}
	} catch (error) {
		console.error("AddMealToCart error: ", error);
	}
}

export const GetUserCart = async (userId: string) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/cart/get_cart_by_user_id/${userId}`, {
			method: 'GET',
			headers: {'Content-Type': 'application/json'},
			credentials: 'include'
		});
		
		const data = await response.json();
		if (response && response.status === 200 && data) {
			console.log("GetUserCart data: ", data);
			return data;
		} else {
			//data && data.message && toast.error(data.message);
			return null;
		}
	} catch (error) {
		console.error("GetUserCart error: ", error);
	}
}

export const UpdateMealQuantityInCart = async (userId: string, mealId: string, quantity: number) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/cart/update-quantity`, {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			credentials: 'include',
			body: JSON.stringify({
				userId,
				mealId,
				quantity
			}),
		});
		
		const data = await response.json();
		if (response && response.status === 200 && data) {
			console.log("UpdateMealQuantityInCart data: ", data);
			return data;
		} else {
			//data && data.message && toast.error(data.message);
			return null;
		}
	} catch (error) {
		console.error("UpdateMealQuantityInCart error: ", error);
	}
}

export const RemoveMealFromCart = async (userId: string, mealId: string) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/cart/remove-meal`, {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			credentials: 'include',
			body: JSON.stringify({
				userId,
				mealId
			}),
		});
		
		const data = await response.json();
		if (response && response.status === 200 && data) {
			console.log("RemoveMealFromCart data: ", data);
			return data;
		} else {
			//data && data.message && toast.error(data.message);
			return null;
		}
	} catch (error) {
		console.error("RemoveMealFromCart error: ", error);
	}
}